module.exports = require('./helpers/bundle-url').getBundleURL('fHglS') + "logo.c51670a8.svg";